const publicationRequestFields = {
  JOURNAL_ARTICLE: 'journal_article',
  BOOK: 'book'
};

export default publicationRequestFields;
